import * as React from 'react';
import EDHighchartsWrapper, { IOptions } from '../EDHighcharts';
import {
  PointOptionsObject,
  SeriesClickEventObject,
  SeriesPieOptions,
  Chart,
} from 'highcharts';
import { findFormatter } from '../../../Utils/Formatters/FindFormatter';

interface IProps {
  title?: string;
  category?: string;
  data?: PointOptionsObject[];
  unitLabel?: string;
  nrDecimals?: number;
  drilldownEvent?: (event: SeriesClickEventObject) => void;
  height?: number;
  afterChartCreated?: (chart: Chart) => void;
}

const parser = findFormatter('TEDFormatCurr').displayer;

/**
 * Cirkeldiagram
 */
class EDPieChart extends React.Component<IProps> {
  getData = (): IOptions => {
    return {
      chart: {
        height: this.props.height,
      },
      title: {
        text:
          this.props.title +
          (this.props.category ? ` - ${this.props.category}` : ''),
      },
      drilldown: {
        activeDataLabelStyle: {
          color: 'black',
          textDecoration: 'none',
        },
      },
      subtitle: {
        text: `Totalt: ${
          this.props.data
            ? parser.display(
                (
                  this.props.data
                    .filter(d => d.y !== undefined)
                    .map(d => d.y) as number[]
                ).reduce((total, value) => total + value),
                true,
                `Decimals="${this.props.nrDecimals}";ForceDecimals="Y"`
              )
            : ''
        } ${this.props.unitLabel ? this.props.unitLabel : 'kr'}`,
      },
      tooltip: {
        pointFormat: '{point.percentage:.1f}%',
      },
      plotOptions: {
        pie: {
          cursor: this.props.drilldownEvent ? 'pointer' : undefined,
          dataLabels: {
            enabled: true,
            format: '{point.percentage:.1f} %',
          },
          showInLegend: true,
          events: {
            click: this.props.drilldownEvent,
          },
          tooltip: {
            pointFormat: '{point.y}',
            valueDecimals:
              this.props.nrDecimals !== undefined ? this.props.nrDecimals : 2,
            valueSuffix: ` ${
              this.props.unitLabel ? this.props.unitLabel : 'kr'
            }`,
          },
        },
      },
      series: [
        {
          data: this.props.data,
        } as SeriesPieOptions,
      ],
      credits: {
        enabled: false,
      },
    };
  };

  render() {
    return (
      <div>
        <EDHighchartsWrapper
          type="pie"
          options={this.getData()}
          afterChartCreated={this.props.afterChartCreated}
        />
      </div>
    );
  }
}

export default EDPieChart;
